/***************************************************************************************************
** isArrayEmpty
***************************************************************************************************/

export default function isArrayNotEmpty(array) {
  return (array && Array.isArray(array) && array.length > 0);
}
